import {Injectable} from '@angular/core';
import {db} from '../db.service';
import {EmployeeRoster} from '../../interfaces/employee-rosters/employee-roster';
import {SyncTimesStaticTable} from '../sync-times-static.table';
import {DateTime} from 'luxon';
import {TimeHelper} from '../../helpers/time-helper';

@Injectable({
  providedIn: 'root'
})
export class EmployeeRostersTable extends SyncTimesStaticTable<EmployeeRoster> {
  constructor() {
    super(db.employeeRosters);
  }

  /**
   *
   * @param dateFrom
   * @param dateTo
   */
  public async getByPeriod(dateFrom: Date | DateTime | string, dateTo: Date | DateTime | string): Promise<EmployeeRoster[]> {
    dateFrom = TimeHelper.getDateString(dateFrom);
    dateTo = TimeHelper.getDateString(dateTo);
    const employeeRosters = await this.getAll()

    return employeeRosters.filter((_employeeRoster: EmployeeRoster) => {
      const date = TimeHelper.getDateString(_employeeRoster.date);
      return date >= dateFrom && date <= dateTo;
    });
  }
}
